var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.71606264,19 L19.2839374,19 C19.8362221,19 20.2839374,18.5522847 20.2839374,18 C20.2839374,17.8271924 20.2391559,17.6573339 20.1539595,17.5069874 L13.3700222,5.53533327 C13.0977389,5.05483328 12.4874874,4.88604033 12.0069874,5.15832366 C11.8495142,5.24755849 11.7192127,5.37786002 11.6299778,5.53533327 L4.84604046,17.5069874 C4.57375713,17.9874874 4.74255009,18.5977389 5.22305007,18.8700222 C5.37339653,18.9552185 5.54325502,19 5.71606264,19 Z M13,17 L12,17 C11.7238576,17 11.5,16.7761424 11.5,16.5 L11.5,15.5 C11.5,15.2238576 11.7238576,15 12,15 L13,15 C13.2761424,15 13.5,15.2238576 13.5,15.5 L13.5,16.5 C13.5,16.7761424 13.2761424,17 13,17 Z M13,14 L12,14 C11.7238576,14 11.5,13.7761424 11.5,13.5 L11.5,10.5 C11.5,10.2238576 11.7238576,10 12,10 L13,10 C13.2761424,10 13.5,10.2238576 13.5,10.5 L13.5,13.5 C13.5,13.7761424 13.2761424,14 13,14 Z",
    id: "Shape",
    fill: "#EF3B28",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionTriangle);
export default __webpack_public_path__ + "static/media/attentionTriangle.26ceed34a70bec448434603d2b812847.svg";
export { ForwardRef as ReactComponent };